module.exports = __webpack_public_path__ + "img/Recipe-XianCi.c86f74d7.png";